
addEventListener("load", App.colorOption)
addEventListener("load", _=> document.querySelectorAll("[data-id=dealSlider]").forEach(el => App.dealSlider(el)))
addEventListener("load", _=> document.querySelectorAll("[data-id=dealSlider2]").forEach(el => App.dealSlider2(el)))
